// extracted by mini-css-extract-plugin
export default {"borderBottom":"AdminMobileStoreSaleStat_borderBottom__fEfQl","moveIcon":"AdminMobileStoreSaleStat_moveIcon__rT5lp","listMoveClick":"AdminMobileStoreSaleStat_listMoveClick__tcO-M"};